import script from "./AppButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppButton.vue?vue&type=script&setup=true&lang=ts"

import "./AppButton.vue?vue&type=style&index=0&id=1bb18b74&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bb18b74"]])

export default __exports__